/**
 * Duplicates backend values: no type is shared between the two applications. They mirror
 * `AiProviderKind.AZURE_SPEECH`, `AiModelFamily.AZURE_SPEECH` and the bounds of `AzureSpeechSettingsDto`
 * (`apps/backend/src/modules/ai/dto/models/azure-speech-settings.dto.ts`). The server stays the
 * authority and rejects any other value.
 */
export const AZURE_SPEECH_KIND = 'azure_speech';
export const AZURE_SPEECH_FAMILY = 'azure_speech';

export const SPEECH_LOCALE_PATTERN = /^[a-z]{2,3}-[A-Z]{2,4}$/;
export const SPEECH_MAX_SPEAKERS_MIN = 2;
export const SPEECH_MAX_SPEAKERS_MAX = 35;
export const SPEECH_PHRASES_MAX_COUNT = 2000;
export const SPEECH_PHRASE_MAX_LENGTH = 200;
export const SPEECH_PHRASE_WEIGHT_MIN = 0;
export const SPEECH_PHRASE_WEIGHT_MAX = 2;
export const AZURE_SPEECH_CHUNK_MAX_SECONDS_MIN = 60;
export const AZURE_SPEECH_CHUNK_MAX_SECONDS_MAX = 7200;
